import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import {
  generate_uuid,
  dateTimeToserver,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { required, validationWrapper, number,isUserName } from "lib/formValidations";

import Modal from "components/Modal";
import { useCore } from "store/core";

// components

export default function Add(props) {
  const core = useCore();
  return (
    <>
      <Modal
        zIndex={992}
        show={props.show}
        handleClose={props.close}
        title={props.title}
      >
        <Formik
          initialValues={{ count: 1,tag:props.tag }}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submit({
              ...transformTranslateFromValues(values),
            });
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-12 md:gap-3">
                <div className="col-span-4">
                    <Field
                      placeholder="نام کاربری"
                      label="نام کاربری :"
                      name="user_name"
                      component={TextField}
                      validate={(value) =>
                        validationWrapper(value, required, isUserName)
                      }
                    />
                  </div>
                  <div className="col-span-4">
                    <Field
                      placeholder="نام"
                      label="نام :"
                      name="first_name"
                      component={TextField}
                      validate={(value) =>
                        validationWrapper(value, required)
                      }
                    />
                  </div>
                  <div className="col-span-4">
                    <Field
                      placeholder="نام خانوادگی"
                      label="نام خانوادگی :"
                      name="last_name"
                      component={TextField}
                       validate={(value) =>
                        validationWrapper(value, required)
                      }
                    />
                  </div>
                  <div className="col-span-4">
                    <Field
                      placeholder="برچسب"
                      label="برچسب :"
                      name="tag"
                      component={TextField}
                    />
                  </div>
                  <div className="col-span-2">
                    <Field
                      placeholder="تعداد"
                      label="تعداد :"
                      name="count"
                      type="number"
                      component={TextField}
                      validate={(value) =>
                        validationWrapper(value, required, number)
                      }
                    />
                  </div>
                </div>

                <div className="modal-footer text-right">
                  <button
                    className="btn btn-primary w-20"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {" "}
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={props.close}
                    className="btn btn-outline-secondary w-20 mr-1"
                  >
                    انصراف
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
